// extracted by mini-css-extract-plugin
export default {"container":"GoalCard_container__NWFVA","iconContainer":"GoalCard_iconContainer__K+a2B"};